<template>
    <div class="nrk bottom-btn">
        <div class="Servic hs">
            <p>吉林医药设计院有限公司专利技术</p>
        </div>
        <img src="img/js-2.jpg" class="img-in pc-display">
        <img src="img/js-4.jpg" class="img-in mobile-display">
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .mobile-display{
        display: none;
    }
     @media (max-width: 768px){
        .Servic p{
            font-size: 18px;
            padding: 18px 0;
            display: block;
            font-weight: bold;
        }
        .mobile-display{
            display: block;
        }
        .pc-display{
            display: none;
        }
    }
</style>